interface BrandMarkProps {
  className?: string
  title?: string
}

export function BrandMark({ className = '', title }: BrandMarkProps) {
  return (
    <svg
      className={`brand-logo ${className}`.trim()}
      viewBox="0 0 48 48"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="48" height="48" rx="13" fill="#09111f" />
      <path d="M35.5 11.3 29.1 17a11 11 0 0 0-5.2-1.3c-4.8 0-8.4 3.5-8.4 8.3s3.6 8.3 8.4 8.3c1.9 0 3.6-.4 5.1-1.3l6.5 5.7A18 18 0 0 1 24 40.8C14.1 40.8 7.2 33.6 7.2 24S14.1 7.2 24 7.2c4.4 0 8.3 1.4 11.5 4.1Z" fill="#635bff" />
      <path d="m35.5 11.3-6.4 5.8a10.9 10.9 0 0 0-5.2-1.4V7.2c4.4 0 8.3 1.4 11.6 4.1Z" fill="#22d3ee" />
      <path d="m29 31 6.5 5.7A17.8 17.8 0 0 1 24 40.8v-8.5c1.9 0 3.6-.4 5-1.3Z" fill="#3478f6" />
      <path d="M15.5 24c0 4.8 3.6 8.3 8.4 8.3v8.5C14.1 40.8 7.2 33.6 7.2 24h8.3Z" fill="#4b6fff" />
    </svg>
  )
}

interface BrandLockupProps {
  className?: string
  compact?: boolean
}

export function BrandLockup({ className = '', compact = false }: BrandLockupProps) {
  return (
    <span className={`brand-lockup ${compact ? 'brand-lockup-compact' : ''} ${className}`.trim()} aria-label="cromaOS">
      <BrandMark />
      <span className="brand-name" aria-hidden="true">croma<span>OS</span></span>
    </span>
  )
}
